import { useQueryClient, useMutation } from "react-query";
import API from "../../../services/API/Social";

export default function useDeletePost(queryKey){

    const queryClient = useQueryClient();

    return useMutation({

        mutationFn: props => API.deletePost(props.id),

        onMutate: async props => {

            await queryClient.cancelQueries({ queryKey: queryKey })

            const previous = queryClient.getQueryData(queryKey)

            queryClient.setQueryData(queryKey, old => {
                const idx = old.pages[props.page - 1].data.findIndex(p => p.id === props.id);
                let copy = {...old};
                copy.pages[props.page - 1].data.splice(idx, 1);
                return copy;
            })

            return { previous }
        },

        onError: (e, props, context) => {
            console.error(props);
            queryClient.setQueryData(queryKey, context.previous)
        },

        onSettled: () => {
            queryClient.invalidateQueries({ queryKey: queryKey })
        },
    })

}